import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { Modal, Spin } from 'components';

const BookMultipleExternalAppointments: React.FC = () => {
  const { search } = useLocation();
  const { mls, mlsNumber, userId } = search
    .replace('?', '')
    .split('&')
    .reduce<Record<string, string[]>>((acc, cur) => {
      const [key, val] = cur.split('=');
      let value = [val];
      if (acc[key]) {
        value = [...acc[key], val];
      }

      return { ...acc, [key]: value };
    }, {});

  useEffect(() => {
    if (mls?.length || mlsNumber?.length || userId?.length) {
      for (let i = 0; i < mlsNumber.length; i += 1) {
        const [oid, number] = mlsNumber[i].split(',');
        const url = `/external/rets/book?mls=${mls[0]}&oid=${oid}&mlsNumber=${number}&userId=${userId[0]}`;

        if (i === mlsNumber.length - 1) {
          window.location.replace(url);
        } else {
          const opened = window.open(url, '_blank');
          if (!opened || opened.closed) {
            Modal.error({
              title: 'Listing dashboards cannot be opened',
              content:
                'You must enable browser pop-ups on this site to open all dashboards for the selected listings in new tabs. Please refresh the page once pop-ups are enabled.',
              centered: true,
            });
            break;
          }
        }
      }
    }
  }, []);

  return (
    <StyledContainer>
      <Spin size="large" />
    </StyledContainer>
  );
};

export default BookMultipleExternalAppointments;

const StyledContainer = styled.div`
  width: 100%;
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
